import { Injectable } from '@angular/core';
import { HttpClient as Http } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { FeactureService } from '../SicarMap/FeactureService.service';

@Injectable({
    providedIn: 'root'
  })
  export class CamposCService {

    constructor( private http: Http, private fService: FeactureService) { }


    ObtenerCamposCartografia(url: string) {
    
      return this.http.get(url + '/query?where=1%3D1&text=&objectIds=&time=&geometry=&' +
      'geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&' +
      'outFields=*&returnGeometry=false&maxAllowableOffset=&geometryPrecision=&outSR=&returnIdsOnly=false&' +
      'returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&' +
      'returnM=false&gdbVersion=&returnDistinctValues=false&returnTrueCurves=false&' +
      '&token='+this.fService.globalToken+'&resultOffset=&resultRecordCount=1&f=pjson').pipe(map(response => response));
    }
  }